import * as React from 'react'
import styled from 'styled-components'
import Button from '../../../../common/src/components/Button'
import { BodyText, InputMed, Spacer } from '../../../../common/src/components/core'

const Root = styled.div`
  display: flex;
  align-items: center;
`

const Box = styled.div`
  flex-grow: 1;
`

interface EditBox2Props {
  defaultValue: string
  onSave: (value: string) => void
  type?: string
}

/**
 * Eventually replaces EditBox
 */
const EditBox2 = (props: EditBox2Props) => {
  const { defaultValue, onSave, type } = props

  const [isEditing, setIsEditing] = React.useState(false)
  const inputRef = React.useRef<HTMLInputElement>(null)
  const handleClickEdit = React.useCallback(() => {
    setIsEditing(true)
  }, [])
  const handleClickCancel = React.useCallback(() => {
    setIsEditing(false)
  }, [])
  const handleClickSave = React.useCallback(() => {
    setIsEditing(false)
    if (inputRef.current) {
      onSave(inputRef.current.value)
    }
  }, [onSave])

  return (
    <Root>
      <Box>
        {isEditing ? (
          <InputMed ref={inputRef} defaultValue={defaultValue} type={type} autoFocus />
        ) : (
          <BodyText color="snow">{defaultValue}</BodyText>
        )}
      </Box>
      <Spacer width={8} />
      {isEditing ? (
        <div>
          <Button size="small" color="snow" onClick={handleClickCancel}>
            cancel
          </Button>
          <Spacer width={8} />
          <Button size="small" color="mint" onClick={handleClickSave}>
            save
          </Button>
        </div>
      ) : (
        <Button size="small" color="snow" onClick={handleClickEdit}>
          edit
        </Button>
      )}
    </Root>
  )
}

export default EditBox2
